<template>
  <div class="small">
    <line-chart :chart-data="dataCollection"></line-chart>
    <button @click="fillData()">Randomize</button>
  </div>
</template>

<script type="ts">
import LineChart from '../helpers/LineChart.js'
import {Component, Vue} from "vue-property-decorator";

@Component({
  name: 'RandomChart',
  components: { LineChart }
})
export default class RandomChart extends Vue {

  dataCollection = {};

  mounted() {
    this.fillData()
  }

  fillData() {
      this.dataCollection = {
        labels: [this.getRandomInt(), this.getRandomInt()],
        datasets: [
          {
            label: 'Data One',
            backgroundColor: '#f87979',
            data: [this.getRandomInt(), this.getRandomInt()]
          }, {
            label: 'Data One',
            backgroundColor: '#f87979',
            data: [this.getRandomInt(), this.getRandomInt()]
          }
        ]
      }
    }

    getRandomInt () {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5
    }
}
</script>

<style>
.small {
  max-width: 600px;
  margin:  150px auto;
}
</style>